
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum NotificationStatus {
	New = 0,
	Read = 1,
	Deleted = 2
}
export namespace NotificationStatus {
	export function getKeys(): Map<NotificationStatus, string> {
		return new Map([[0, 'New'], [1, 'Read'], [2, 'Deleted']]);
	}
}
